import {
    IonButton,
    IonCol,
    IonInput,
    IonItem,
    IonLabel,
    IonRow,
} from "@ionic/react";
import React, { useState } from "react";
import { CreateHorseShowRatingInput } from "../../API";
import { Event, HorseShowRating } from "../../models";
import { createHorseShowRating } from "../../utilities/horseShowRating/HorseShowRating";
import ErrorAlert from "../Errors/ErrorAlert";
import Spinner from "../Spinners/Spinner";
import SelectRating from "./SelectHorseShowRating";

interface _Props {
    event: Event
    horseShowRating?: HorseShowRating
    onSubmit: Function
}

const HorseShowRatingForm: React.FC<_Props> = ({event, horseShowRating, onSubmit}) => {
    const [isMounted, setIsMounted] = useState(true);
    const [isDisabled, setIsDisabled] = useState(true);
    const [governingBody, setGoverningBody] = useState(horseShowRating?.governingBody || "");
    const [rating, setRating] = useState(horseShowRating?.rating || "");
    const [isLoading, setIsLoading] = useState(false);

    const [error, setError] = useState<string>("");

    const verifyForm = () => {
        if (!governingBody) {
            setError("Error: include a governing body.");
            return false;
        }
        return true;
    }


    const handleCreateHorseShowRating = async () => {
        const input: CreateHorseShowRatingInput = {
            governingBody,
            rating,
            eventId: event.id
        };
        const createResult = await createHorseShowRating(input);
        if (createResult.isSuccess) {
            onSubmit(createResult.result);
        } else {
            setError("Error: could not create the rating.");
        }
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        const isValid = verifyForm();
        if (isValid) {
            await handleCreateHorseShowRating();
            setIsDisabled(true);
        }
        setIsLoading(false);
    }

    return (
        <>
            {error && <ErrorAlert width="12" error={error}/>}
            <form>
                <IonRow>
                    <IonCol>
                        <IonItem color="white">
                            <IonLabel position="stacked">Governing Body</IonLabel>
                            <IonInput 
                                type="text"
                                value={governingBody}
                                aria-required={true}
                                onIonChange={e => {
                                    if(isMounted) setIsDisabled(false);
                                    else setIsMounted(true);
                                    setGoverningBody(e.detail.value!)
                                }}
                            />
                        </IonItem>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <SelectRating onInputChange={(rating: string) => setRating(rating)} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol sizeMd="4">
                        {isLoading ?
                            <Spinner />
                            :
                            <IonButton
                                disabled={isDisabled}
                                className="ion-margin-top"
                                color="tertiary"
                                expand="block"
                                onClick={handleSubmit}
                            >
                                {isDisabled ? "Saved" : "Save"}
                            </IonButton>
                        }
                    </IonCol>
                </IonRow>
            </form>
        </>
    );
};

export default HorseShowRatingForm;